import { LocalSessionKeys } from './LocalSession';

export const RegionCodes = Object.freeze({
  US: 'us',
  EU: 'eu',
  AU: 'au'
});

const region_code_key = LocalSessionKeys.regionCode;

export function InitializeRegion() {
  getRegionCode();
}

function getRegionCodeFromQueryString() {
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  const regionCodeFromQuery = params.get('regionCode') || '';
  return Object.values(RegionCodes).find((rc) => regionCodeFromQuery.toLowerCase() === rc.toLowerCase()) || null;
}

function getRegionCodeFromHost() {
  const host = window.location.host || '';
  return Object.values(RegionCodes).find((rc) => host.toLowerCase().includes(`.${rc.toLowerCase()}.`)) || null;
}

function getRegionCodeFromOidcJwt() {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key?.startsWith('oidc.user:')) {
      continue;
    }

    const oidcUser = TryParseJson(localStorage.getItem(key));
    const idToken = oidcUser?.id_token;
    const jwtPayload = idToken ? TryParseJwtPayload(idToken) : null;
    const regionCodeFromJwt = jwtPayload?.region_code || oidcUser?.profile?.region_code || '';
    const matchingRegionCode = Object.values(RegionCodes).find((rc) => regionCodeFromJwt.toLowerCase() === rc.toLowerCase());

    if (matchingRegionCode) {
      return matchingRegionCode;
    }
  }

  return null;
}

function TryParseJson(value: string | null) {
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function TryParseJwtPayload(token: string) {
  const segments = token.split('.');
  if (segments.length < 2) {
    return null;
  }

  try {
    const payload = segments[1].replace(/-/g, '+').replace(/_/g, '/');
    const normalizedPayload = payload.padEnd(payload.length + ((4 - (payload.length % 4)) % 4), '=');
    return JSON.parse(atob(normalizedPayload));
  } catch {
    return null;
  }
}

export function getRegionCodeFromPath(pathname: string) {
  const pathSegments = pathname.split('/').filter(Boolean);
  const possibleRegionCode = pathSegments[0] || '';

  return Object.values(RegionCodes).find((rc) => possibleRegionCode.toLowerCase() === rc.toLowerCase()) || null;
}

export function getRegionCode() {
  const resolvedRegionCode =
    getRegionCodeFromPath(window.location.pathname) ||
    getRegionCodeFromQueryString() ||
    getRegionCodeFromHost() ||
    getRegionCodeFromOidcJwt() ||
    localStorage.getItem(region_code_key) ||
    RegionCodes.US;

  if (localStorage.getItem(region_code_key) !== resolvedRegionCode) {
    setRegionCode(resolvedRegionCode);
  }

  return resolvedRegionCode;
}

export function clearRegionCode() {
  localStorage.removeItem(region_code_key);
}

function setRegionCode(regionCode: string) {
  localStorage.setItem(region_code_key, regionCode);
}
